import { cx, css } from '@linaria/core'
import { TextXS, TextXL, elMb1, elMb5 } from '@reapit/elements'
import React from 'react'

export type QuickFilterStatus = 'Signed' | 'Blocked' | 'Expired' | 'Pending' | 'Draft'
export interface QuickFilterItem {
  title: QuickFilterStatus
  value: string
}

export interface QuickFiltersCardProps {
  filterBy: string
  items: QuickFilterItem
  isActive?: boolean
  onClick?: (status: QuickFilterStatus | null) => void
}

const quickFilterCardStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border: none;
  width: 160px;
  height: 96px;
  padding: 0.75rem 1rem;
  background-color: var(--color-grey-lightest, #f2f4f6);
  border-radius: 0.5rem;
  cursor: pointer;

  &:focus,
  &:focus-visible {
    outline: 2px solid var(--intent-primary, #4e56ea);
  }

  &.is-active {
    background-color: var(--intent-primary, #4e56ea);

    & > *,
    & > *.el-intent-primary {
      color: white;
    }

    & > .status-label {
      color: var(--color-purple-100);
    }
  }
`
export const QuickFiltersCard: React.FC<QuickFiltersCardProps> = React.memo(
  ({ filterBy, items, isActive, onClick }) => {
    const handleClick = () => {
      onClick?.(isActive ? null : items.title)
    }

    return (
      <button className={cx(quickFilterCardStyle, isActive && 'is-active')} onClick={handleClick}>
        <TextXS className={cx('status-label', elMb1)} intent="secondary">
          {filterBy}
        </TextXS>
        <TextXS hasBoldText className={elMb5}>
          {items.title}
        </TextXS>
        <TextXL intent="primary" hasBoldText>
          {items.value}
        </TextXL>
      </button>
    )
  },
)
